import type {
  CreateScenarioRequest,
  ScenarioDetailResponse,
  ScenarioListResponse,
  UpdateScenarioRequest,
} from '@/domains/scenario/types/scenario-management.types';
import { APIS, URLS } from '@/shared/config/urls';
// import { reqDelete, reqGet, reqPost, reqPut } from "@/utils/request";
import { request } from '@/shared/utils/request';

// [GET] Scenario List
export const fetchScenarioList = async (params: string = ''): Promise<ScenarioListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.scenarioList(params)}`;
  return await request.get(url);
};

// [GET] Detail Scenario Info
export const fetchDetailScenario = async (scenarioId: string): Promise<ScenarioDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailScenario(scenarioId)}`;
  return await request.get(url);
};

// [DELETE] Delete Scenario
export const deleteScenario = async (scenarioId: string): Promise<void> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteScenario(scenarioId)}`;
  return await request.delete(url);
};

// [PUT] Update Scenario
export const updateScenario = async (
  scenarioData: UpdateScenarioRequest
): Promise<ScenarioDetailResponse> => {
  const { scenario_id, ...body } = scenarioData;
  const url = `${URLS.BACK_DSH}${APIS.updateScenario(scenario_id)}`;
  return await request.put(url, body);
};

// [POST] Create Scenario
export const createScenario = async (
  scenarioData: CreateScenarioRequest
): Promise<ScenarioDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createScenario()}`;
  return await request.post(url, scenarioData);
};
